<template>
  <div class="bg-grey-lighter pb-8">
    <div class="container mx-auto p-5 bg-white rounded-lg shadow-lg justify-around min-div-width">
      <h1 class="p-8 text-navy mb-10 text-center">Thanks for submitting your request for accreditation</h1>

      <p class="text-navy opacity-75 mb-1 text-center p-8">An email has been sent to the broker to notify them that you
        have requested accreditation on their behalf. </p>
      <p class="text-navy opacity-75 mb-2 text-center p-8">Once the broker has confirmed their accreditation request and
        completed onboarding, we will notify you via email.</p>
      <div class="w-full mt-20 flex justify-center p-8">
        <button @click="onSubmit" class="bg-green hover:opacity-75 text-white font-bold py-3 px-4 rounded text-lg"
                type="button">
          New Accreditation Request
        </button>
        <router-link to="/aggregator/brokers"
                     class="bg-white hover:opacity-75 text-green border no-underline font-bold py-3 px-4 rounded text-lg ml-8">
          Home
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AggregatorThanksPage',
  metaInfo: {
    title: 'Accreditation Request Successful | SocietyOne Personal Loans',
  },
  mounted() {
    this.$ga.page('/accreditation/');
    this.$gtm.trackView('AggregatorThanksPage', '/accreditation');
  },
  methods: {
    onSubmit() {
      this.$root.$emit('createNewBroker');
    },
  },
};
</script>
<style scoped>
.min-div-width {
  min-width: 1132px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Aggregator/AggregatorThanksPage.vue